import { ServiceInsightDesktopCardProps } from '../../types';
import { ServiceInsightDetails } from '../service-insight-details';
import styles from '../../customer-account.module.scss';

export const ServiceInsightDesktopCard = ({
  serviceInsights,
  serviceInsightTranslation,
  handleRedirectUrlToAlp
}: ServiceInsightDesktopCardProps) => {
  return (
    <div
      className={`${styles['service-insight-separator']} p-3`}
      data-testid="service-insight"
    >
      <ServiceInsightDetails
        serviceInsights={serviceInsights}
        serviceInsightTranslation={serviceInsightTranslation}
        handleRedirectUrlToAlp={handleRedirectUrlToAlp}
        isDeskTop
      />
    </div>
  );
};
